module.exports = __webpack_public_path__ + "img/coupon.12c38231.jpg";